import React from 'react';
import { Card } from 'react-bootstrap';
import styles from './Services.module.css';
import web from '../../Images/web-programming.png';
import marketing from '../../Images/bullhorn.png';
import ui from '../../Images/ui.png';
import search from '../../Images/search.png';

const Services = () => {
  return (
    <div className="text-center py-5">
      <div className="text-center">
        <h3 className="title">Services</h3>
        <h1 className="subtitle">What I Am Great At</h1>
        <p className="text-secondary">
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupida non
          proident, sunt in culpa qui officia
        </p>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className={styles.service}>
            <img className={styles.img} src={web} alt="" />
            <Card.Body>
              <h4 className="subtitle">Web Development</h4>
              <p className="text-secondary">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Suscipit eius temporibus
              </p>
            </Card.Body>
          </div>
        </div>

        <div className="col-md-3">
          <div className={styles.service}>
            <img className={styles.img} src={ui} alt="" />
            <Card.Body>
              <h4 className="subtitle">UI/UX Design</h4>
              <p className="text-secondary">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Suscipit eius temporibus eligendi.
              </p>
            </Card.Body>
          </div>
        </div>

        <div className="col-md-3">
          <div className={styles.service}>
            <img className={styles.img} src={search} alt="" />
            <Card.Body>
              <h4 className="subtitle">Web Research</h4>
              <p className="text-secondary">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Suscipit eius temporibus eligendi.
              </p>
            </Card.Body>
          </div>
        </div>

        <div className="col-md-3">
          <div className={styles.service}>
            <img className={styles.img} src={marketing} alt="" />
            <Card.Body>
              <h4 className="subtitle">Marketing</h4>
              <p className="text-secondary">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Suscipit eius temporibus eligendi.
              </p>
            </Card.Body>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
